export const chartPalette = ['bg-chart-1', 'bg-chart-2', 'bg-chart-3', 'bg-chart-4/70'] as const;
export type ChartState = 'ready' | 'loading' | 'empty' | 'error';
